import React from 'react';
import ConclusionHome from "./ConclusionHome"
import { pmRoot} from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";

const ConclusionRouteConfig = {
  routes: [
		{
    path: `${pmRoot}/project/project-conclusion`,
    exact: true,
    name: <IntlMessages id={"menu.conclusion"}/>,
    element: <ConclusionHome/>,
    auth: [],
  },
	]
};
export default ConclusionRouteConfig;